// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".layer-widget-panel[data-v-628c9de1] {\n  height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  margin-right: 0px;\n  padding-right: 10px;\n}\n.layer-widget-panel .button-2-secondary[data-v-628c9de1] {\n  margin-top: 24px;\n  width: 100%;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
